import type { Fund } from '../../types/fund'

export function formatMoney(value: number | null | undefined): string {
  const amount = Number(value)
  return new Intl.NumberFormat('es-EC', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(amount) ? amount : 0)
}

export function readList<T>(response: { data: unknown }, message: string): T[] {
  if (!Array.isArray(response.data)) {
    throw new Error(message)
  }
  return response.data
}

function round2(value: number) {
  return Math.round(value * 100) / 100
}

export function termPreview(input: {
  principal: number | null
  totalInterest: number | null
  installments: number | null
  payment: number | null
  addedToPrincipal: number | null
  deductedAtDisbursement: number | null
}) {
  const months = Number(input.installments) || 0
  const principal = input.principal
  const interest = input.totalInterest
  const added = Number(input.addedToPrincipal) || 0
  const deducted = Number(input.deductedAtDisbursement) || 0
  let totalDue: number | null = null
  let payment = input.payment
  if (principal != null && interest != null && months > 0) {
    totalDue = round2(principal + interest)
    payment = round2(totalDue / months)
  } else if (payment != null && months > 0) {
    totalDue = round2(payment * months)
  }
  const cashIn = principal != null ? round2(principal - added - deducted) : null
  return { payment, totalDue, cashIn }
}

export function statusLabel(fund: Fund) {
  if (fund.status === 'closed') return 'Cerrado'
  if (fund.status === 'exhausted') return 'Agotado'
  return 'Abierto'
}

export function canSpend(fund: Fund) {
  return fund.status === 'open' && fund.disponible > 0
}

export function canRepay(fund: Fund) {
  return fund.repayable && fund.status !== 'closed' && (fund.porPagar ?? 0) > 0
}

export function canReceive(fund: Fund) {
  return fund.status === 'open' || fund.status === 'exhausted'
}

export function fundFilterOptions(funds: { id: number; detail: string }[]) {
  return funds.map((fund) => ({ id: `f-${fund.id}`, label: fund.detail }))
}
